<!--
  A page to see all users
-->

<template>
  <div v-loading="loading" class="users-list">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <router-link :to="{ name: 'home' }">
          Home
        </router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Users</el-breadcrumb-item>
    </el-breadcrumb>
    <main-title>Users</main-title>
    <!-- client users -->
    <subtitle id="section-clients">Clients</subtitle>
    <ul>
      <li v-for="user in listClients" :key="user.user">
        <router-link :to="{ name: 'user', params: { user: user.user }}">
          {{user.email}}
        </router-link>
      </li>
    </ul>
    <!-- admin users -->
    <subtitle id="section-admins">Admins</subtitle>
    <ul>
      <li v-for="user in listAdmins" :key="user.user">
        <router-link :to="{ name: 'user', params: { user: user.user }}">
          {{user.email}}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import State from '../../stores/state.js'

export default {
  data () {
    return {
      state: State.state,
      loading: true,
      listUsers: [], // all users
    }
  },
  computed: {
    // client users
    listClients () { return this.listRole('client') },
    // admin users
    listAdmins () { return this.listRole('admin') },
    // the current connected user
    currentUser () { return this.state.user ? this.state.user.user : null },
  },
  inject: ['onerror'],
  // load users
  created () {
    this.loadData()
  },
  watch: {
    // reaload users
    'state.user' () { this.loadData() },
  },
  methods: {
    // load users
    loadData () {
      this.loading = true
      State.listUsers().then((data) => {
        this.loading = false
        this.listUsers = data.users.slice()
        this.listUsers.sort((a, b) => (a.email > b.email) - (a.email < b.email))
      }, this.onerror)
    },
    // filters users by role, and identifies the current user
    listRole (role) {
      return this.listUsers.filter(x => x.role === role)
        .map(x => x.user !== this.currentUser ? x
          : { ...x, user: 'me' })
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  .users-list a {
    color: $--color-text-regular;
    /*font-weight: bold;*/
    text-decoration: none;
  }
  .users-list a:hover {
    text-decoration: underline;
  }
  .users-list ul {
    list-style-type: none;
  }
  .users-list li {
    margin-top: 0.2em;
    margin-bottom: 0.2em;
  }
</style>
